import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AITripDataService } from '../ai-trip-data.service';
import { FormBuilder } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-ai-trip-second',
  templateUrl: './ai-trip-second.component.html',
  styleUrls: ['./ai-trip-second.component.css']
})
export class AiTripSecondComponent implements OnInit {
  tripDetails: any;

  tripType: string = 'Solo'; // default selection
  travelOptions: string[] = ['Solo', 'Family', 'Partner', 'Friends'];

  newInterest: string = '';
  interestsList: string[] = [];
  selectedInterests: string[] = [];
  loadingInterests = false;

  constructor(private router: Router, private fb: FormBuilder,
    private aitripDataService: AITripDataService, private meta: Meta, private title: Title) { }

  ngOnInit(): void {
    this.metaTagAdd()  //////  Meta tags add for SEO  //////
    this.tripDetails = this.aitripDataService.getTripData();
    if (!this.tripDetails) {
      this.router.navigate(['ai-trip']);
    }
    else {
      this.generateInterestSuggestions();
    }
  }
  metaTagAdd() {
    this.title.setTitle('AI Powered Trip Planner | My Yatra 360');

    this.meta.updateTag({
      name: 'description',
      content: 'Let our smart AI assistant craft your perfect travel itinerary — from hidden gems to top attractions. Plan your dream trip effortlessly with My Yatra 360.'
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'AI Trip Planner Pilgrimage Tours'
    });
  }
  selectTravelType(type: string) {
    this.tripType = type;
  }

  generateInterestSuggestions() {
    this.interestsList = []
    this.loadingInterests = true; // Show loader
    let destination = this.tripDetails.destination
    const prompt = `
    A trip to ${destination}, 
    Generate a personalized list of 6–10 interest tags the user might want to explore during this trip. These should be short and clickable labels like:
     Temples
     Culture
     Adventure
     Hidden Gems
     Street Food
     Shopping
     Lakeside Walks
     Wellness & Spa
     Historical Monuments

    Ensure a balance between cultural, leisure, and discovery activities. Output only the interest tags as a comma-separated list.
    Only respond in this format:
    City: [Corrected or Interpreted City Name]
    Interests: [Comma-separated list of interest tags]
     `;
    this.aitripDataService.generateTripPlan(prompt).pipe()
      .subscribe({
        next: (res: any) => {
          const text = res.choices[0].message.content;
          const cityMatch = text.match(/City:\s*(.+)/i);
          const interestsMatch = text.match(/Interests:\s*(.+)/i);

          const city = cityMatch?.[1]?.trim() || this.tripDetails.destination; // fallback
          const interests = interestsMatch?.[1]?.split(',').map(i => i.trim()).filter(i => i) || [];
          this.tripDetails.destination = city; // Optional: update corrected city name
          this.interestsList = interests;
          this.loadingInterests = false;
        },
        error: err => {
          console.error('OpenAI Error:', err);
          this.interestsList = ['Attractions', 'Shopping', 'Food']; // fallback list
          this.loadingInterests = false; // Hide loader
        }
      });
  }

  toggleInterest(interest: string): void {
    const index = this.selectedInterests.indexOf(interest);
    if (index > -1) {
      this.selectedInterests.splice(index, 1); // remove if exists
    } else {
      this.selectedInterests.push(interest); // add if not
    }
  }

  addNewInterest(): void {
    const trimmedInterest = this.newInterest.trim();
    if (trimmedInterest && !this.interestsList.includes(trimmedInterest)) {
      // this.interestsList.push(trimmedInterest);
      this.selectedInterests.push(trimmedInterest); // auto-select the newly added
    }
  }

  aitripiteneryRedirect() {
    let data = {
      destination: this.tripDetails.destination,
      startDate: this.tripDetails.startDate,
      endDate: this.tripDetails.endDate,
      interests: this.selectedInterests.join(', '),
      tripType: this.tripType
    }
    if (data) {
      this.aitripDataService.setTripData(data);
      this.router.navigate(['ai-itinerary']);
    }
    else {
      alert('')
    }
  }
}
